export default {
    DOCUMENTS: "documents"
};
